// Curated country list for billing. Currency rule: CA -> CAD, everything else -> USD.
// ISO-3166 alpha-2 codes. "Other" (empty string sent as null) falls back to USD.
export const COUNTRIES = [
  { code: "CA", name: "Canada" },
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "IE", name: "Ireland" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "CH", name: "Switzerland" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "PT", name: "Portugal" },
  { code: "AT", name: "Austria" },
  { code: "PL", name: "Poland" },
  { code: "IN", name: "India" },
  { code: "SG", name: "Singapore" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "ZA", name: "South Africa" },
  { code: "BR", name: "Brazil" },
  { code: "MX", name: "Mexico" },
  { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" },
  { code: "HK", name: "Hong Kong" },
  { code: "AF", name: "Afghanistan" },
];

export const currencyForCountry = (code) => (String(code || "").toUpperCase() === "CA" ? "CAD" : "USD");

// Canada time zones, used as a fallback when the browser locale carries no region subtag.
const TZ_COUNTRY = {
  "America/Toronto": "CA", "America/Vancouver": "CA", "America/Edmonton": "CA",
  "America/Winnipeg": "CA", "America/Halifax": "CA", "America/Montreal": "CA",
  "America/Regina": "CA", "America/St_Johns": "CA", "America/Moncton": "CA",
};

// Best-effort guess of the visitor's country from their browser locale/timezone.
// Returns an ISO code present in COUNTRIES, or "" when it can't be determined.
export const detectCountryCode = () => {
  try {
    const langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (const l of langs) {
      const parts = String(l || "").split("-");
      if (parts.length > 1) {
        const region = parts[parts.length - 1].toUpperCase();
        if (COUNTRIES.some((c) => c.code === region)) return region;
      }
    }
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TZ_COUNTRY[tz]) return TZ_COUNTRY[tz];
  } catch (e) { /* ignore */ }
  return "";
};
